module.exports = __webpack_public_path__ + "img/b01.c55cecbe.png";